(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[666],{

/***/ 11293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ TiptapTextEditor; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@tiptap/react/dist/index.js + 2 modules
var dist = __webpack_require__(45823);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-color/dist/index.js
var extension_color_dist = __webpack_require__(90353);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-list-item/dist/index.js
var extension_list_item_dist = __webpack_require__(34565);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-text-style/dist/index.js
var extension_text_style_dist = __webpack_require__(23621);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-character-count/dist/index.js
var extension_character_count_dist = __webpack_require__(88776);
// EXTERNAL MODULE: ./node_modules/@tiptap/starter-kit/dist/index.js + 17 modules
var starter_kit_dist = __webpack_require__(90173);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-document/dist/index.js
var extension_document_dist = __webpack_require__(20336);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-highlight/dist/index.js
var extension_highlight_dist = __webpack_require__(50601);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-paragraph/dist/index.js
var extension_paragraph_dist = __webpack_require__(26022);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-text/dist/index.js
var extension_text_dist = __webpack_require__(52701);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-underline/dist/index.js
var extension_underline_dist = __webpack_require__(48510);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-text-align/dist/index.js
var extension_text_align_dist = __webpack_require__(96279);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-link/dist/index.js + 1 modules
var extension_link_dist = __webpack_require__(99404);
;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/TiptapConfigs.tsx












var tiptapExtensions = [
    extension_document_dist/* default */.Z,
    extension_paragraph_dist/* default */.Z,
    extension_text_dist/* default */.Z,
    extension_color_dist/* Color.configure */.I.configure({
        types: [
            extension_text_style_dist/* default.name */.Z.name,
            extension_list_item_dist/* default.name */.Z.name
        ]
    }),
    extension_text_style_dist/* default.configure */.Z.configure({
        types: [
            extension_list_item_dist/* default.name */.Z.name
        ]
    }),
    starter_kit_dist/* default.configure */.Z.configure({
        bulletList: {
            keepMarks: true,
            keepAttributes: false
        },
        orderedList: {
            keepMarks: true,
            keepAttributes: false
        }
    }),
    extension_underline_dist/* default */.Z,
    extension_text_align_dist/* default.configure */.Z.configure({
        types: [
            "heading",
            "paragraph",
            "image"
        ],
        alignments: [
            "left",
            "center",
            "right"
        ],
        defaultAlignment: "left"
    }),
    extension_highlight_dist/* default.configure */.ZP.configure({
        multicolor: true
    }),
    extension_link_dist/* default.configure */.ZP.configure({
        openOnClick: true,
        autolink: false,
        protocols: [
            "ftp",
            "mailto"
        ],
        HTMLAttributes: {
            // Change rel to different value
            // Allow search engines to follow links(remove nofollow)
            rel: "noopener noreferrer",
            // Remove target entirely so links open in current tab
            target: null,
            validate: function(href) {
                return /^https?:\/\//.test(href);
            }
        }
    }),
    extension_character_count_dist/* default */.Z, 
];

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-placeholder/dist/index.js
var extension_placeholder_dist = __webpack_require__(93237);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/tiptapStyles.module.scss
var tiptapStyles_module = __webpack_require__(39596);
var tiptapStyles_module_default = /*#__PURE__*/__webpack_require__.n(tiptapStyles_module);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(98388);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-hard-break/dist/index.js
var extension_hard_break_dist = __webpack_require__(35525);
;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/TiptapTextEditor.tsx
"use client";











var TiptapTextEditor = function(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Type here..." : _placeholder, _style = param.style, style = _style === void 0 ? {} : _style, _className = param.className, className = _className === void 0 ? "" : _className, _wrapperClassName = param.wrapperClassName, wrapperClassName = _wrapperClassName === void 0 ? "" : _wrapperClassName, renderToolbarProps = param.renderToolbarProps, _onTextUpdate = param.onTextUpdate, onTextUpdate = _onTextUpdate === void 0 ? undefined : _onTextUpdate, _maxLength = param.maxLength, maxLength = _maxLength === void 0 ? undefined : _maxLength, _RenderToolbar = param._RenderToolbar, _disableNewParaOnNextLine = param.disableNewParaOnNextLine, disableNewParaOnNextLine = _disableNewParaOnNextLine === void 0 ? false : _disableNewParaOnNextLine, _keepLastUsedTextTag = param.keepLastUsedTextTag, keepLastUsedTextTag = _keepLastUsedTextTag === void 0 ? false : _keepLastUsedTextTag, _removeHTMLFromPastedString = param.removeHTMLFromPastedString, removeHTMLFromPastedString = _removeHTMLFromPastedString === void 0 ? true : _removeHTMLFromPastedString;
    var editor = (0,dist/* useEditor */.jE)({
        extensions: (0,_to_consumable_array/* default */.Z)(tiptapExtensions).concat([
            extension_placeholder_dist/* default.configure */.Z.configure({
                placeholder: placeholder,
                emptyNodeClass: "first:before:tw-font-inter first:before:tw-text-gray-400 first:before:tw-float-left first:before:tw-content-[attr(data-placeholder)] first:before:tw-pointer-events-none first:before:tw-h-0 first:before:tw-p-0"
            }),
            extension_character_count_dist/* default.configure */.Z.configure({
                limit: maxLength
            }),
            extension_hard_break_dist/* default.extend */.Z.extend({
                addKeyboardShortcuts: function addKeyboardShortcuts() {
                    var _this = this;
                    return {
                        Enter: function() {
                            var isInList = _this.editor.isActive("bulletList") || _this.editor.isActive("orderedList");
                            if (disableNewParaOnNextLine && !isInList) {
                                return _this.editor.commands.setHardBreak();
                            }
                            return false;
                        }
                    };
                }
            }), 
        ]),
        parseOptions: {
            preserveWhitespace: true
        },
        editorProps: {
            transformPastedText: function transformPastedText(text) {
                return text.replace(/\xA0/g, " ");
            },
            transformPastedHTML: function transformPastedHTML(html) {
                if (!removeHTMLFromPastedString) return html;
                return html.replace(/<\/?[^>]+(>|$)/g, ""); // replace(/<\/[^>]+(>|$)/g, '').
            }
        },
        content: typeof content === "string" ? content : "",
        editable: !disabled,
        onUpdate: function(param) {
            var editor = param.editor;
            var text = editor === null || editor === void 0 ? void 0 : editor.getHTML();
            if (keepLastUsedTextTag && editor.isActive("heading") && (!text || text === "<p></p>")) {
                editor.commands.selectAll();
                editor.chain().focus().toggleHeading({
                    level: editor.getAttributes("heading").level
                }).run();
            }
            onTextUpdate === null || onTextUpdate === void 0 ? void 0 : onTextUpdate({
                text: text === "<p></p>" ? "" : text,
                characterCount: editor.storage.characterCount.characters()
            });
        },
        onCreate: function(param) {
            var editor = param.editor;
            var text = editor === null || editor === void 0 ? void 0 : editor.getHTML();
            onTextUpdate === null || onTextUpdate === void 0 ? void 0 : onTextUpdate({
                text: text,
                characterCount: editor.storage.characterCount.characters()
            });
        },
        immediatelyRender: false
    });
    // Adding extra dependency will unselect the selected text node after editing is done on it
    (0,react.useEffect)(function() {
        // if (disabled)
        if (editor && editor.getHTML() !== content) editor === null || editor === void 0 ? void 0 : editor.commands.setContent(content);
    }, [
        editor,
        disabled,
        content
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(!className ? (tiptapStyles_module_default()).editorContentWrapper : "", wrapperClassName),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* EditorContent */.kg, {
                editor: editor,
                style: style,
                className: (0,bundle_mjs/* twMerge */.m6)((tiptapStyles_module_default()).tiptap, className),
                maxLength: maxLength
            }),
            editor && renderToolbarProps && renderToolbarProps(editor),
            editor && _RenderToolbar && /*#__PURE__*/ (0,jsx_runtime.jsx)(_RenderToolbar, {
                editor: editor
            })
        ]
    });
};


/***/ }),

/***/ 82522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ ToolbarMenu; }
});

// UNUSED EXPORTS: HyperLink

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/Undo.js


function Undo(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.828 7l2.536 2.535L6.95 10.95 2 6l4.95-4.95 1.414 1.415L5.828 5H13a8 8 0 110 16H4v-2h9a6 6 0 000-12H5.828z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/Redo.js


function Redo(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M18.172 7H11a6 6 0 000 12h9v2h-9a8 8 0 010-16h7.172l-2.536-2.536L17.05 1.05 22 6l-4.95 4.95-1.414-1.415L18.172 7z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/OrderedList.js


function OrderedList(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.75 3.5H4.717l-1.467.393v1.553l1-.268V8.5H3V10h4V8.5H5.75v-5zM10 4h11v2H10V4zm0 7h11v2H10v-2zm0 7h11v2H10v-2zm-7.125-2.375a2.125 2.125 0 113.812 1.292l-.004.006L5.316 18.5H7V20H3v-1.121l2.472-2.844a.625.625 0 10-1.094-.466l-.013.306h-1.49v-.25z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/Paragraph.js


function Paragraph(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12 6v15h-2v-5a6 6 0 010-12h10v2h-3v15h-2V6h-3zm-2 0a4 4 0 100 8V6z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/Strikethrough.js


function Strikethrough(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M17.154 14c.23.516.346 1.09.346 1.72 0 1.342-.524 2.392-1.571 3.147C14.88 19.622 13.434 20 11.586 20c-1.64 0-3.263-.381-4.87-1.145v-2.254c1.52.877 3.075 1.316 4.666 1.316 2.551 0 3.83-.732 3.839-2.197a2.21 2.21 0 00-.648-1.603l-.12-.117H3v-2h18v2h-3.846zm-4.078-3H7.629a4.086 4.086 0 01-.481-.522C6.716 9.92 6.5 9.246 6.5 8.452c0-1.236.466-2.287 1.397-3.153C8.83 4.433 10.271 4 12.222 4c1.471 0 2.879.328 4.222.984v2.152c-1.2-.687-2.515-1.03-3.946-1.03-2.48 0-3.719.782-3.719 2.346 0 .42.218.786.654 1.099.436.313.974.563 1.613.75.62.18 1.297.414 2.03.699z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/HorizontalBreak.js


function HorizontalBreak(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M2 11h2v2H2v-2zm4 0h12v2H6v-2zm14 0h2v2h-2v-2z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/ClearFormatting.js


function ClearFormatting(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.651 14.065L11.605 20H9.574l1.35-7.661-7.41-7.41L4.93 3.515 20.485 19.07l-1.414 1.414-6.42-6.42zm-.878-6.535l.27-1.53h-1.8l-2-2H20v2h-5.927L13.5 9.257 11.773 7.53z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/AddImage.js


function AddImage(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height, _style = param.style, style = _style === void 0 ? {} : _style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M21 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2zm.008-12c.548 0 .992.445.992.993V13h-2V5H4v13.999L14 9l3 3v2.829l-3-3L6.827 19H14v2H2.992A.993.993 0 012 20.007V3.993A1 1 0 012.992 3h18.016zM8 7a2 2 0 110 4 2 2 0 010-4z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/AlignCenter.js


function AlignCenter(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 4h18v2H3V4zm2 15h14v2H5v-2zm-2-5h18v2H3v-2zm2-5h14v2H5V9z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/AlignLeft.js


function AlignLeft(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 4h18v2H3V4zm0 15h14v2H3v-2zm0-5h18v2H3v-2zm0-5h14v2H3V9z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/AlignRight.js


function AlignRight(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 4h18v2H3V4zm4 15h14v2H7v-2zm-4-5h18v2H3v-2zm4-5h14v2H7V9z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/Highlight.js


function Highlight(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.572 8.027a5 5 0 10-5.101 2.945 6.994 6.994 0 015.1-2.945zm-3.418 9.92a6.995 6.995 0 000-5.892 5 5 0 110 5.89zm-6.88-7.92a6.995 6.995 0 005.1 2.946 5 5 0 11-5.1-2.946z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/Hyperlink.js


function Hyperlink(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.06 8.111l1.415 1.414a7 7 0 010 9.9l-.354.353a7 7 0 11-9.9-9.9l1.415 1.415a5 5 0 107.071 7.071l.354-.354a5 5 0 000-7.07l-1.415-1.415 1.415-1.414zm6.718 6.01l-1.414-1.414a5 5 0 00-7.071-7.07l-.354.353a5 5 0 000 7.07l1.415 1.415-1.415 1.414-1.414-1.414a7 7 0 010-9.9l.354-.353a7 7 0 119.9 9.9z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/H1.js


function H1(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16zm8-12v12h-2v-9.796l-2 .536V8.67L19.5 8H21z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/H2.js


function H2(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4 4v7h7V4h2v16h-2v-7H4v7H2V4h2zm14.5 4a3.75 3.75 0 012.978 6.03l-.148.18L18.034 18H22v2h-7v-1.556l4.82-5.546a1.75 1.75 0 10-3.065-1.292l-.005.144h-2A3.75 3.75 0 0118.5 8z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/H3.js


function H3(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M22 8l-.002 2-2.505 2.883a3.752 3.752 0 01-.993 7.367 3.751 3.751 0 01-3.682-3.033l1.964-.382a1.75 1.75 0 10.924-1.895l-1.307-1.547L19.35 10H15V8h7zM4 4v7h7V4h2v16h-2v-7H4v7H2V4h2z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/H4.js


function H4(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16zm9-12v8h1.5v2H22v2h-2v-2h-5.5v-1.34l5-8.66H22zm-2 3.133L17.19 16H20v-4.867z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/H5.js


function H5(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M22 8v2h-4.323l-.464 2.636A4.006 4.006 0 0122.25 16.5a4 4 0 01-7.846 1.103l1.923-.551a2 2 0 10.363-1.804l-1.81-.904L16 8h6zM4 4v7h7V4h2v16h-2v-7H4v7H2V4h2z"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/H6.js


function H6(param) {
    var _width = param.width, width = _width === void 0 ? 14 : _width, _height = param.height, height = _height === void 0 ? 14 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M21.097 8l-2.598 4.5a4 4 0 11-3.453 1.981L18.788 8h2.309zM4 4v7h7V4h2v16h-2v-7H4v7H2V4h2zm14.5 10.5a2 2 0 100 4 2 2 0 000-4z"
        })
    });
}

// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/toolbar-icons/NewToolbarIcons.tsx



function ItalicIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: props.color || "#111C36",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M16.318 7.063h-5.553M13.233 16.936H7.68M13.85 7.063l-3.702 9.87"
            })
        ]
    }));
}
/* eslint no-undef: 0 */ // --> OFF
function BoldIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: props.color || "#111C36",
            d: "M7.948 17V6.09h4.368c.803 0 1.472.12 2.008.358s.94.568 1.21.99c.27.42.404.903.404 1.45 0 .426-.085.8-.256 1.123-.17.32-.404.583-.703.789a2.882 2.882 0 01-1.012.431v.107a2.49 2.49 0 012.056 1.262c.228.387.341.849.341 1.385 0 .579-.143 1.096-.431 1.55-.284.451-.705.808-1.262 1.07-.558.264-1.245.395-2.062.395h-4.66zm2.307-1.886h1.88c.643 0 1.111-.122 1.406-.367.295-.249.442-.579.442-.991 0-.302-.072-.568-.218-.799a1.483 1.483 0 00-.623-.543c-.267-.132-.585-.197-.954-.197h-1.933v2.897zm0-4.458h1.71c.316 0 .596-.055.841-.165.249-.114.444-.274.586-.48a1.25 1.25 0 00.218-.74c0-.394-.14-.712-.42-.954-.277-.241-.671-.362-1.183-.362h-1.752v2.7z"
        })
    }));
}
function UnderlineIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: props.color || "#111C36",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.2",
            d: "M15.43 6v5.143a3.429 3.429 0 01-6.858 0V6M6.857 18h10.286"
        })
    }));
}
function UnorderedListIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: props.color || "#111C36",
            stroke: "#fff",
            strokeWidth: "0.4",
            d: "M10.417 17.05a.55.55 0 110-1.1h7.833a.55.55 0 110 1.1h-7.833zm0-4.5a.55.55 0 110-1.1h7.833a.55.55 0 110 1.1h-7.833zm0-4.5a.55.55 0 110-1.1h7.833a.55.55 0 110 1.1h-7.833zM6.556 17.8c-.377 0-.693-.127-.96-.385A1.22 1.22 0 015.2 16.5c0-.357.13-.658.396-.915.267-.258.583-.385.96-.385.376 0 .692.127.96.385.266.257.395.558.395.915s-.129.658-.396.915a1.326 1.326 0 01-.96.385zm0-4.5c-.377 0-.693-.127-.96-.385A1.22 1.22 0 015.2 12c0-.357.13-.658.396-.915.267-.258.583-.385.96-.385.376 0 .692.127.96.385.266.257.395.558.395.915s-.129.658-.396.915a1.326 1.326 0 01-.96.385zm0-4.5c-.377 0-.693-.127-.96-.385A1.22 1.22 0 015.2 7.5c0-.357.13-.658.396-.915.267-.258.583-.385.96-.385.376 0 .692.127.96.385.266.257.395.558.395.915s-.129.658-.396.915a1.326 1.326 0 01-.96.385z"
        })
    }));
}
function FontColorIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_161_3202)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: props.color || "#111C36",
                        d: "M8.979 14.5H7.348l3.664-10.182h1.775L16.45 14.5h-1.63l-2.88-8.332h-.079L8.98 14.5zm.273-3.987h5.29v1.292h-5.29v-1.292z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        stroke: (props === null || props === void 0 ? void 0 : props.chosenColor) || "#111C36",
                        strokeWidth: "3",
                        d: "M4 18L20 18"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_161_3202",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H24V24H0z"
                    })
                })
            })
        ]
    }));
}

// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(98388);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WidgetProperties/ColorPicker.tsx
var ColorPicker = __webpack_require__(50096);
;// CONCATENATED MODULE: ./src/components/WidgetMaker/WidgetDnD/components/TiptapTextEditor/ToolbarMenu.tsx




























var buttonReset = constants/* btnReset */.eH + " hover:tw-bg-[#111C360F] ";

var ToolbarMenu = function(param) {
    var _uploadImageToS3AndGetLink = param.uploadImageToS3AndGetLink, uploadImageToS3AndGetLink = _uploadImageToS3AndGetLink === void 0 ? null : _uploadImageToS3AndGetLink, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _allowedEditorOptions = param.allowedEditorOptions, allowedEditorOptions = _allowedEditorOptions === void 0 ? [] : _allowedEditorOptions, _removeEditorOptions = param.removeEditorOptions, removeEditorOptions = _removeEditorOptions === void 0 ? [] : _removeEditorOptions, editor = param.editor, _showFormattors = param.showFormattors, showFormattors = _showFormattors === void 0 ? true : _showFormattors, _className = param.className, className = _className === void 0 ? "" : _className, _defaultTextColor = param.defaultTextColor, defaultTextColor = _defaultTextColor === void 0 ? "#000000" : _defaultTextColor;
    // const { editor } = useCurrentEditor();
    // useEffect(() => {
    //   updateEditorRef(editor);
    // }, [editor]);
    if (!editor) {
        return null;
    }
    var editorChain = function() {
        return editor.chain().focus();
    };
    var addImage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var file, imageUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!uploadImageToS3AndGetLink) {
                            return [
                                2
                            ];
                        }
                        if (!(e.target.files && e.target.files.length > 0)) return [
                            3,
                            2
                        ];
                        file = e.target.files[0];
                        return [
                            4,
                            uploadImageToS3AndGetLink("img", file)
                        ];
                    case 1:
                        imageUrl = _state.sent();
                        if (imageUrl) {
                            // editorChain().setImage({ src: imageUrl }).run();
                            editorChain().insertContent([
                                {
                                    type: "image",
                                    attrs: {
                                        src: imageUrl
                                    }
                                }
                            ]).run();
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function addImage(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleTextSelection = function() {
        editor.view.state.selection.empty && editor.state.doc.textContent.trim().length && editor.commands.selectAll();
    };
    var menuOptions = {
        bold: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                handleTextSelection();
                editorChain().toggleBold().run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, "tw-h-[24px] tw-overflow-hidden tw-rounded-[4px]"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoldIcon, {
                color: editor.isActive("bold") && "#2B74D8",
                className: (0,bundle_mjs/* twMerge */.m6)(editor.isActive("bold") ? " tw-bg-[#2B74D81F]" : "")
            })
        }),
        italic: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                handleTextSelection();
                editorChain().toggleItalic().run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, "tw-h-[24px] tw-overflow-hidden tw-rounded-[4px]"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItalicIcon, {
                color: editor.isActive("italic") && "#2B74D8",
                className: (0,bundle_mjs/* twMerge */.m6)(editor.isActive("italic") ? " tw-bg-[#2B74D81F]" : "")
            })
        }),
        underline: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                handleTextSelection();
                editorChain().toggleUnderline().run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, "tw-h-[24px] tw-overflow-hidden tw-rounded-[4px]"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnderlineIcon, {
                color: editor.isActive("underline") && "#2B74D8",
                className: (0,bundle_mjs/* twMerge */.m6)(editor.isActive("underline") ? " tw-bg-[#2B74D81F]" : "")
            })
        }),
        strike: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                handleTextSelection();
                editorChain().toggleStrike().run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, editor.isActive("strike") ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Strikethrough, {})
        }),
        image: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "dib ds-m4 relative ds-p4 ds-pv2 image-wrapper",
            style: {
                opacity: disabled ? 0.3 : 1
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    id: "file-upload",
                    type: "file",
                    className: "dn",
                    accept: ".png, .jpg, .jpeg",
                    style: {
                        maxWidth: "100%"
                    },
                    onChange: addImage,
                    title: "as",
                    name: "as",
                    disabled: disabled
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    htmlFor: "file-upload",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddImage, {
                        width: 18
                    })
                })
            ]
        }),
        para: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editorChain().setParagraph().run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, editor.isActive("paragraph") ? "tw-rounded-[4px] tw-bg-[#e0e0e0]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {})
        }),
        h1: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editorChain().toggleHeading({
                    level: 1
                }).run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, editor.isActive("heading", {
                level: 1
            }) ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(H1, {})
        }),
        h2: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editorChain().toggleHeading({
                    level: 2
                }).run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, editor.isActive("heading", {
                level: 2
            }) ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(H2, {})
        }),
        h3: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editorChain().toggleHeading({
                    level: 3
                }).run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, editor.isActive("heading", {
                level: 3
            }) ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(H3, {})
        }),
        h4: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editorChain().toggleHeading({
                    level: 4
                }).run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, editor.isActive("heading", {
                level: 4
            }) ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(H4, {})
        }),
        h5: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editorChain().toggleHeading({
                    level: 5
                }).run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, editor.isActive("heading", {
                level: 5
            }) ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(H5, {})
        }),
        h6: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editorChain().toggleHeading({
                    level: 6
                }).run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, editor.isActive("heading", {
                level: 6
            }) ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(H6, {})
        }),
        ul: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editorChain().toggleBulletList().run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, "tw-h-[24px] tw-overflow-hidden  tw-rounded-[4px]"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnorderedListIcon, {
                color: editor.isActive("bulletList") && "#2B74D8",
                className: (0,bundle_mjs/* twMerge */.m6)(editor.isActive("bulletList") ? " tw-bg-[#2B74D81F]" : "")
            })
        }),
        ol: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editorChain().toggleOrderedList().run();
            },
            disabled: disabled,
            className: classnames_default()(buttonReset, editor.isActive("orderedList") ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderedList, {})
        }),
        hr: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editorChain().setHorizontalRule().run();
            },
            className: buttonReset,
            disabled: disabled,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalBreak, {})
        }),
        alignL: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editor.isActive({
                    textAlign: "left"
                }) ? editorChain().unsetTextAlign().run() : editorChain().setTextAlign("left").run();
            },
            className: classnames_default()(buttonReset, editor.isActive({
                textAlign: "left"
            }) ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlignLeft, {})
        }),
        alignC: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editor.isActive({
                    textAlign: "center"
                }) ? editorChain().unsetTextAlign().run() : editorChain().setTextAlign("center").run();
            },
            className: classnames_default()(buttonReset, editor.isActive({
                textAlign: "center"
            }) ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlignCenter, {})
        }),
        alignR: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                e.preventDefault();
                editor.isActive({
                    textAlign: "right"
                }) ? editorChain().unsetTextAlign().run() : editorChain().setTextAlign("right").run();
            },
            className: classnames_default()(buttonReset, editor.isActive({
                textAlign: "right"
            }) ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlignRight, {})
        }),
        fontColor: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorTool, {
            Image: /*#__PURE__*/ (0,jsx_runtime.jsx)(FontColorIcon, {
                chosenColor: editor.getAttributes("textStyle").color || defaultTextColor
            }),
            editorChain: editorChain,
            itemKey: "color",
            editor: editor,
            defaultTextColor: defaultTextColor
        }),
        highlight: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorTool, {
            Image: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight, {}),
            editorChain: editorChain,
            itemKey: "highlight",
            editor: editor,
            defaultTextColor: defaultTextColor
        }),
        hyperlink: /*#__PURE__*/ (0,jsx_runtime.jsx)(HyperLink, {
            editorChain: editorChain,
            editor: editor
        })
    };
    var renderList = function() {
        var allItems = (allowedEditorOptions === null || allowedEditorOptions === void 0 ? void 0 : allowedEditorOptions.length) ? Object.keys(menuOptions) : [];
        var itemsToRender = allItems.reduce(function(acc, cur) {
            if (allowedEditorOptions === null || allowedEditorOptions === void 0 ? void 0 : allowedEditorOptions.length) {
                if (allowedEditorOptions.includes(cur)) {
                    acc.push(cur);
                }
            } else if (!removeEditorOptions.includes(cur)) {
                acc.push(cur);
            }
            return acc;
        }, []);
        return itemsToRender;
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("toolbar-wrapper", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-items-center",
                children: renderList.map(function(renderItem) {
                    return menuOptions[renderItem];
                })
            }),
            showFormattors && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-end items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            editorChain().clearNodes().run();
                        },
                        className: buttonReset,
                        disabled: disabled,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearFormatting, {
                            width: 12
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            editorChain().undo().run();
                        },
                        disabled: disabled,
                        className: buttonReset,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Undo, {
                            width: 12
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            editorChain().redo().run();
                        },
                        disabled: disabled,
                        className: buttonReset,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Redo, {
                            width: 12
                        })
                    })
                ]
            })
        ]
    });
};
function ColorTool(param) {
    var Image = param.Image, editor = param.editor, editorChain = param.editorChain, itemKey = param.itemKey, _defaultTextColor = param.defaultTextColor, defaultTextColor = _defaultTextColor === void 0 ? "#000000" : _defaultTextColor;
    var ref = (0,react.useState)(false), showTooltip = ref[0], setShowTooltip = ref[1];
    var tooltipRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(e) {
            var ref;
            if (!((ref = e.composedPath()) === null || ref === void 0 ? void 0 : ref.includes(tooltipRef.current))) {
                e.stopPropagation();
                closeTooltip();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // const toggleTooltip = () => setShowTooltip(!showTooltip);
    var closeTooltip = function() {
        return setShowTooltip(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-relative tw-h-[24px] tw-rounded-[4px] hover:!tw-bg-[#111C360F]",
        ref: tooltipRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPicker */.z, {
            onColorSubmit: function(_, hex) {
                // handleColorChange(e, hex, data, parentConfig, key)
                editor.view.state.selection.empty && editor.commands.selectAll();
                itemKey === "color" ? editorChain().setColor(hex).run() : editorChain().setHighlight({
                    color: hex
                }).run();
            },
            customStyle: {
                background: "none",
                width: "max-content",
                height: "auto"
            },
            name: "Choose color",
            value: editor.getAttributes("textStyle").color || defaultTextColor,
            showColorPicker: showTooltip,
            setShowColorPicker: setShowTooltip,
            children: Image
        })
    });
}
function HyperLink(param) {
    var editor = param.editor, editorChain = param.editorChain;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(""), hyperlink = ref1[0], setHyperlink = ref1[1];
    var ref2 = (0,react.useState)(false), isPreviousHyperlinkSet = ref2[0], setIsPreviousHyperlinkSet = ref2[1];
    var ref3 = (0,react.useState)(false), showHyperlinkTooltip = ref3[0], setShowHyperlinkTooltip = ref3[1];
    (0,react.useEffect)(function() {
        var handleOutsideClick = function(e) {
            var ref1;
            if ((ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.contains(e.target)) {
                return;
            }
            setHyperlink("");
            setShowHyperlinkTooltip(false);
        };
        window.addEventListener("click", handleOutsideClick);
        return function() {
            window.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    var removeHyperlink = function() {
        editorChain().extendMarkRange("link").unsetLink().run();
        setHyperlink("");
        setShowHyperlinkTooltip(false);
    };
    var saveHyperlink = function() {
        if (hyperlink === null || hyperlink === void 0 ? void 0 : hyperlink.trim()) {
            editorChain().extendMarkRange("link").setLink({
                href: hyperlink.trim(),
                target: "_blank"
            }).run();
            setShowHyperlinkTooltip(false);
        } else {
            removeHyperlink();
        }
    };
    var toggleTooltip = function() {
        var previousUrl = editor.getAttributes("link").href;
        if (previousUrl) {
            setHyperlink(previousUrl || "");
        }
        if (previousUrl && !isPreviousHyperlinkSet) {
            setIsPreviousHyperlinkSet(true);
        }
        if (!previousUrl && isPreviousHyperlinkSet) {
            setIsPreviousHyperlinkSet(false);
        }
        setShowHyperlinkTooltip(function(val) {
            return !val;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-relative tw-inline-block",
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: toggleTooltip,
                className: classnames_default()(buttonReset, "tw-h-[24px] tw-w-[24px] tw-overflow-hidden  tw-rounded-[4px]", editor.isActive("link") ? "tw-rounded-[4px] tw-bg-[#dcdcdc]" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hyperlink, {})
            }),
            showHyperlinkTooltip && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-absolute tw-z-[5] tw-flex tw-items-center tw-bg-[#f7f7f7] tw-p-[12px]",
                style: {
                    top: "100%",
                    right: "-30px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: hyperlink,
                        className: "ma0 tw-w-[160px]",
                        onChange: function(e) {
                            return setHyperlink(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: saveHyperlink,
                        className: "ds-ml12 ma0 ds-text-[#3D6AFD] tw-bg-transparent",
                        children: "Add"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: removeHyperlink,
                        // disabled={!isPreviousHyperlinkSet}
                        className: classnames_default()("ds-ml12 ma0 ds-text-[#3D6AFD] tw-bg-transparent"),
                        children: "Remove"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 39596:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tiptap":"tiptapStyles_tiptap__Dxzgz","editorContentWrapper":"tiptapStyles_editorContentWrapper__R2gfx"};

/***/ })

}]);